import React from 'react';
import { Col, Container, NavLink, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer-bg">
            <Container>
                <Row className="text-white">
                    <Col xs={12} md={3}>
                        <div className="single-footer-widget justify-content-center justify-content-md-start">
                            <div className="widget-title">
                                <h2>Location</h2>
                            </div>
                            <div className="widget-content">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d946.0492580732925!2d73.82940328805653!3d18.47473227120001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc295b9812d5ac3%3A0x76f8c9ad70085de1!2sSavali%20Old%20Age%20Care%20and%20Elderly%20Recovery%20Center!5e0!3m2!1sen!2sin!4v1675763131141!5m2!1sen!2sin"
                                width="200" 
                                height="200" 
                                title='Location'
                                style={{border:0}} 
                                allowfullscreen="" 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade">                                    
                                </iframe>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="single-footer-widget justify-content-center justify-content-md-start">
                            <div className="widget-title">
                                <h2>Resources</h2>
                            </div>
                            <div className="widget-content">
                                <NavLink className="footer-link">Guidelines</NavLink>
                                <NavLink className="footer-link">Patient Form</NavLink>
                                <NavLink className="footer-link">Brochure</NavLink>
                                <NavLink className="footer-link">FAQ</NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="single-footer-widget justify-content-center justify-content-md-start">
                            <div className="widget-title">
                                <h2>Services</h2>
                            </div>
                            <div className="widget-content">
                                <NavLink className="footer-link"><Link to="/" className='footer-link'>Post Operative Care</Link></NavLink>
                                <NavLink className="footer-link"><Link to="/" className='footer-link'>Physical Therapy</Link></NavLink>
                                <NavLink className="footer-link"><Link to="/" className='footer-link'>Rehabilitation</Link></NavLink>
                                <NavLink className="footer-link"><Link to="/" className='footer-link'>Geriatric Care</Link></NavLink>
                                <NavLink className="footer-link"><Link to="/" className='footer-link'>Old Age Home</Link></NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="single-footer-widget justify-content-center justify-content-md-start">
                            <div className="widget-title">
                                <h2>Our Address</h2>
                            </div>
                            <div className="widget-content">
                                <NavLink className="footer-link">Savali Old Age Home and Elderly Recovery Center</NavLink>
                                <NavLink className="footer-link">Near Laxmi Mata Mandir, Mahadev Nagar </NavLink>
                                <NavLink className="footer-link">Hingne Khurd, Pune - 411051</NavLink>
                                <NavLink className="footer-link">Email: savalioldage@gmail.com</NavLink>
                                <NavLink className="footer-link">Contact:+91 8668529894</NavLink>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="footer-copy-right text-center text-white" >
                <p className='mb-0'>&copy; 2022 - <span className="developer"></span> | All Rights Reserved by सावली Old Age Home and Elderly Recovery Center</p>
            </div>
        </div>
    );
};

export default Footer;